import {helpers, required, minValue, maxValue} from "@vuelidate/validators";
import {maxLength} from "@vuelidate/validators";
import {useIndividualPacking} from "@/hooks/useIndividualPacking";


const {withMessage} = helpers;

const fileSize = (size) => (files) => {
    if (!files || !(files instanceof FileList)) {
        return true
    }

    let totalFilesSize = 0;

    Array.from(files).forEach(file => {
        totalFilesSize += Math.round((file.size / 1024) * 100) / 100
    })

    return totalFilesSize <= size
}

export const IPFieldsRules = {
    mixins: [useIndividualPacking],
    props: {
        error4: {
            type: [String],
            default: BX.message('CATALOG_INDIVIDUAL_ERROR_4')
        },
        error5: {
            type: [String],
            default: BX.message('CATALOG_INDIVIDUAL_ERROR_5')
        },
        error6: {
            type: [String],
            default: BX.message('CATALOG_INDIVIDUAL_ERROR_6')
        },
        error7: {
            type: [String],
            default: BX.message('CATALOG_INDIVIDUAL_ERROR_7')
        },
        error8: {
            type: [String],
            default: BX.message('CATALOG_INDIVIDUAL_ERROR_8')
        },
        error9: {
            type: [String],
            default: BX.message('CATALOG_INDIVIDUAL_ERROR_9')
        },
    },
    computed: {
        getFieldRules() {
            return (field) => {
                let {isRequired = false, type, min = null, max = null} = field;

                return {
                    ...(min && {minValue: withMessage(this.error5 + ` ${min}`, minValue(min))}),
                    ...(max && {maxValue: withMessage(this.error6 + ` ${max}`, maxValue(max))}),
                    ...(type === 'text' && {maxLength: withMessage(this.error7, maxLength(250))}),
                    ...(type === 'textarea' && {maxLength: withMessage(this.error8, maxLength(500))}),
                    ...(type === 'file' && {fileSize: withMessage(this.error9, fileSize(10 * 1024))}),
                    ...(isRequired && {required: withMessage(this.error4, required)})
                }
            }
        }
    }
}